const patterns = [
  { regex: /^User (activated|deactivated) successfully\.$/, translate: (t, match) => t(match[1] === 'activated' ? 'User activated successfully.' : 'User deactivated successfully.') },
  { regex: /^Transaction (\d+) exceeds the attachment limit\.$/, translate: (t, match) => t('Transaction {{number}} exceeds the attachment limit.', { number: match[1] }) },
  { regex: /^A maximum of (\d+) transactions is allowed per batch\.$/, translate: (t, match) => t('A maximum of {{count}} transactions is allowed per batch.', { count: match[1] }) },
  { regex: /^Duplicates transaction (\d+)\.$/, translate: (t, match) => t('Duplicates transaction {{number}}.', { number: match[1] }) },
];

export const translateApiMessage = (t, message, fallback = '') => {
  const source = message || fallback;
  if (!source) return '';
  const translated = t(source);
  if (translated !== source) return translated;
  for (const pattern of patterns) {
    const match = source.match(pattern.regex);
    if (match) return pattern.translate(t, match);
  }
  return translated;
};
